var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { on: { click: (event) => _vm.isOutside(event) } },
    [
      _c("modal", {
        attrs: { width: _vm.width, height: _vm.height },
        on: { "hide-modal": _vm.close },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _vm.formSteps.length !== 0
                  ? _c(
                      "div",
                      { staticClass: "modal-inner w-full px-2" },
                      [
                        _vm.formSteps[_vm.currentStep].formTitle
                          ? _c("IntakeForm", {
                              staticClass: "relative",
                              attrs: {
                                steps: _vm.formatFormSteps(
                                  _vm.formSteps[_vm.currentStep].questions
                                ),
                                fieldsToMonitor: _vm.fieldsToMonitor(
                                  _vm.formSteps[_vm.currentStep].questions
                                ),
                                buttonText: _vm.buttonText,
                                buttonStyling: "items-right",
                                showButton: true,
                              },
                              on: {
                                submitHandler: _vm.contactUsHandler,
                                progress: _vm.next,
                                "hide-modal": function ($event) {
                                  return _vm.$emit("hide-modal")
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "content",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "text-left" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-2xl font-bold pb-1/2",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formSteps[
                                                      _vm.currentStep
                                                    ].formHeader
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("hr", { staticClass: "pb-1/2" }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "text-base pb-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formSteps[
                                                      _vm.currentStep
                                                    ].formSubHeader
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                684160478
                              ),
                            })
                          : _c(_vm.formSteps[_vm.currentStep].type, {
                              tag: "component",
                              attrs: {
                                isAnonymous: _vm.isAnonymousCustomer,
                                step: _vm.formSteps[_vm.currentStep],
                                buttonStyling: "items-center",
                                showButton: true,
                              },
                              on: { progress: _vm.next },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header-content",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-center space-bottom-1",
                                          },
                                          [
                                            _vm.formSteps[_vm.currentStep].title
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-2xl font-bold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formSteps[
                                                          _vm.currentStep
                                                        ].title
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.formSteps[_vm.currentStep]
                                              .subTitle
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-base space-top-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formSteps[
                                                          _vm.currentStep
                                                        ].subTitle
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                2761938875
                              ),
                            }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }